import { useSearchParams } from "next/navigation";

export const useCoupon = () => {
  const searchParams = useSearchParams();
  const coupon = searchParams.get("coupon");
  const tab = searchParams.get("tab");

  const percentStr = searchParams.get("percent");
  const percent = percentStr !== null ? Number.parseInt(percentStr) : null;

  return {
    coupon,
    tab,
    percent,
  };
};
